<template>
    <v-main style="background:#f1f1f1;">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card flat class="elevation-1">
              <v-toolbar dense dark flat color="black">
                <v-icon>mdi-account-circle</v-icon> <span class="ml-2 ellipsify">Cadastrar-se</span>
                <v-spacer></v-spacer>
                <v-btn small depressed round color="red darken-2" v-if="$store.getters.logged">sair</v-btn>
              </v-toolbar>
              <v-card-text>
                <v-form>
                    <v-text-field filled v-model="name" label="Nome" autocomplete="name" xhide-details name="name" placeholder=" " prepend-inner-icon="mdi-email" type="text"></v-text-field>
                    <v-menu
                      ref="birthday_menu"
                      v-model="birthday_menu"
                      :close-on-content-click="false"
                      :return-value.sync="birthday"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          filled
                          v-model="birthday"
                          label="Data de nascimento"
                          xhide-details
                          name="birthday"
                          prepend-inner-icon="mdi-email"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="birthday" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="birthday_menu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.birthday_menu.save(birthday)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                    <v-select
                        :items="gender_items"
                        v-model="gender"
                        filled
                        label="Filled style"
                    ></v-select>
                    <v-text-field filled v-model="mobile" label="Celular" autocomplete="mobile" xhide-details name="mobile" placeholder=" " prepend-inner-icon="mdi-phone" type="text"></v-text-field>
                    <v-text-field filled v-model="document_cpf" label="CPF" autocomplete="document_cpf" xhide-details name="document_cpf" placeholder=" " prepend-inner-icon="mdi-plus" type="text"></v-text-field>
                    <v-text-field filled v-model="email" label="E-mail" autocomplete="email" xhide-details name="email" placeholder=" " prepend-inner-icon="mdi-email" type="text"></v-text-field>
                    <v-text-field filled hide-details v-model="password" id="password" autocomplete="current-password" xhide-details label="Senha" placeholder=" " name="password" prepend-inner-icon="mdi-lock" type="password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-btn block depressed tile color="success" @click="useRegister()">Entrar</v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
</template>

<script>
export default {
    data() {
        return {
            name: "Ronaldo Moreira",
            birthday: "31/03/1984",
            birthday_menu: "",
            gender: "m",
            gender_items: [
                {
                    text: 'Masculino',
                    value: 'm'
                }
            ],
            mobile: "47997644843",
            document_cpf: "05401293992",
            email: "elj0k3r@gmail.com",
            password: "12345"
        }
    },
    mounted () {
        if (this.$route.query.logout) {
            this.store.dispatch('login', {});
        }
    },
    methods: {
        useRegister() {
          const payload = {
              name: this.name,
              birthday: this.birthday,
              gender: this.gender,
              mobile_country: '55',
              mobile: this.mobile,
              document_cpf: this.document_cpf,
              email: this.email,
              password: this.password
          }

          this.$api
          .post('/user.register', payload)
          .then(response => {
            if (response.data.id) {
                this.$store.dispatch('login', response.data);

                this.$root.$emit('notification', {
                    type: 'success',
                    title: 'Sucesso',
                    message: 'Login efetuado com sucesso',
                });

                this.$router.push('/sistema/admin');
            }
          })
          .catch((error) => {
            this.$root.$emit('GlobalSnackbar', {type: 'error', message: error.response.data.errors[0]});
          });
        }
    },
}
</script>